import { useField } from 'react-final-form';
import styled from 'styled-components';
import { PhotoComponent } from '../components/photos';
import { BaseSectionHeader } from '../components/ui';
import { useFieldArray } from 'react-final-form-arrays';
import { useCameraViewContext } from '../CameraView/context';

type Props = {
  theme?: 'grey' | 'white';
};

const AllPhotosSectionWrapper = styled.div<{ withBorder?: boolean }>`
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  outline: ${props => (props.withBorder ? '1px solid #3994de' : 'none')};
`;

const AllPhotosHeader = styled(BaseSectionHeader)`
  background: #ffffff;

  & > span {
    font-size: 14px;
    font-weight: 700;
    line-height: 16.41px;
    color: #000;
  }
`;

const PhotosWrapper = styled.div`
  background: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 7px 5px;
  padding: 0px 12px 16px 12px;
`;

const themeOptions = {
  white: {
    background: '#fff',
    gradeBackground: '#2222220A'
  },
  grey: {
    background: '#F5F5F5',
    gradeBackground: '#fff'
  }
};

export const OdometerImages = ({ theme = 'grey' }: Props) => {
  const odometerFirst = useField(`interior_questions.images.0`);
  const odometerSecond = useField(`drive_cycles.images.0`);

  const { background } = themeOptions[theme];

  const { fields } = useFieldArray(`interior_questions.images`);
  const { fields: driveCyclesFields } = useFieldArray(`drive_cycles.images`);

  const removeFirst = () => {
    fields.update(0, { ...fields.value[0], url: '', url_thumb: '' });
  };

  const removeSecond = () => {
    driveCyclesFields.update(0, { ...driveCyclesFields.value[0], url: '', url_thumb: '' });
  };

  const { openCameraView } = useCameraViewContext();

  const handleCameraClick = () => {
    if (theme !== 'grey') {
      openCameraView('drive_cycles', 0, false);
    }
  };

  return (
    <AllPhotosSectionWrapper style={{ background }} withBorder={false}>
      <AllPhotosHeader isExpanded={false} style={{ background }}>
        <span>{`Upload photos`}</span>
      </AllPhotosHeader>
      <PhotosWrapper style={{ padding: 0 }}>
        <PhotoComponent
          withUploadLabel={false}
          localRemove={removeFirst}
          {...odometerFirst}
          displaySize="md"
        />
        <PhotoComponent
          onClick={handleCameraClick}
          withUploadLabel={false}
          localRemove={removeSecond}
          {...odometerSecond}
          displaySize="md"
        />
      </PhotosWrapper>
    </AllPhotosSectionWrapper>
  );
};
